<zenith-toast-wrapper>
    <zenith-toast [attr.zn-appearance]="appearance" [attr.zn-icon-name]="icon" zn-open>
        <zenith-toast-content>{{content}}</zenith-toast-content>
        <zenith-toast-actions>
            <zenith-button zn-icon-name="cancel"
        zn-appearance="plain"
        (click)="onCloseToast()"></zenith-button>
    </zenith-toast-actions>
  </zenith-toast>
</zenith-toast-wrapper>
